/* WallboxWelt – Optimierungen 23.08.2026 */
(() => {
  const enhanceTechnicalRows = (container) => {
    const technicalPanel = container.querySelector('[data-ww-panel="technical"]');
    if (!technicalPanel) return;

    technicalPanel.querySelectorAll('.metafield-rich_text_field li').forEach((item) => {
      if (item.dataset.wwTechRowReady === 'true') return;
      item.dataset.wwTechRowReady = 'true';

      const source = item.querySelector(':scope > p') || item;
      const strong = source.querySelector(':scope > strong:first-child');
      if (!strong) return;

      const nodes = Array.from(source.childNodes);
      const strongIndex = nodes.indexOf(strong);
      if (strongIndex < 0) return;

      const label = document.createElement('span');
      label.className = 'ww-tech-label';

      const value = document.createElement('span');
      value.className = 'ww-tech-value';

      nodes.slice(0, strongIndex + 1).forEach((node) => label.appendChild(node));
      nodes.slice(strongIndex + 1).forEach((node) => value.appendChild(node));

      item.replaceChildren(label, value);
      item.classList.add('ww-tech-row');
    });
  };

  const initProductTabsEnhancements = () => {
    document.querySelectorAll('[data-ww-product-tabs]').forEach((container) => {
      enhanceTechnicalRows(container);

      const manufacturerPanel = container.querySelector('[data-ww-panel="manufacturer"]');
      if (manufacturerPanel && !manufacturerPanel.querySelector('.ww-product-tabs__manufacturer-card')) {
        const logo = manufacturerPanel.querySelector('.ww-product-tabs__manufacturer-logo');
        const info = manufacturerPanel.querySelector('.ww-product-tabs__manufacturer');

        if (info) {
          const card = document.createElement('div');
          card.className = 'ww-product-tabs__manufacturer-card';
          if (logo) logo.before(card);
          else info.before(card);
          if (logo) card.appendChild(logo);
          card.appendChild(info);
        }
      }
    });
  };

  const initProductDetailsShortcut = () => {
    if (document.documentElement.dataset.wwProductDetailsShortcut === 'true') return;
    document.documentElement.dataset.wwProductDetailsShortcut = 'true';

    document.addEventListener(
      'click',
      (event) => {
        const link = event.target.closest('a[data-smooth-scroll-to-tabs], a[href="#product-tabs-section"]');
        if (!link) return;

        const tabs = document.querySelector('[data-ww-product-tabs]');
        const descriptionTab = tabs?.querySelector('[data-ww-tab="description"]');
        if (descriptionTab) descriptionTab.click();
      },
      true
    );
  };

  const initBrandsCta = () => {
    document.querySelectorAll('.mega-menu__content--marken .mega-menu__inner--marken').forEach((inner) => {
      if (inner.querySelector('.mega-menu__brands-all-wrap')) return;
      const list = inner.querySelector('.mega-menu__list--marken');
      if (!list) return;

      const wrap = document.createElement('div');
      wrap.className = 'mega-menu__brands-all-wrap';
      wrap.innerHTML = '<a class="mega-menu__brands-all" href="/pages/marken"><span>Alle Marken ansehen</span><span aria-hidden="true">→</span></a>';
      list.insertAdjacentElement('afterend', wrap);
    });
  };

  const initProductCardBadges = (root = document) => {
    const cards = root.querySelectorAll ? root.querySelectorAll('.product-card-wrapper') : [];

    cards.forEach((card) => {
      const price = card.querySelector('.card-information .price');
      if (!price || !price.classList.contains('price--on-sale') || price.classList.contains('price--sold-out')) return;

      const priceSaleBadge = price.querySelector('.price__badge-sale');
      const innerBadgeZone = card.querySelector('.card__inner .card__badge');
      if (!priceSaleBadge || !innerBadgeZone) return;

      const saleText = priceSaleBadge.textContent.trim();
      let overlaySale = Array.from(innerBadgeZone.querySelectorAll('.badge')).find((badge) => {
        return badge.textContent.trim() === saleText && !badge.classList.contains('badge--14a');
      });

      if (!overlaySale) {
        overlaySale = priceSaleBadge.cloneNode(true);
        overlaySale.removeAttribute('id');
        innerBadgeZone.insertBefore(overlaySale, innerBadgeZone.firstChild);
      }

      overlaySale.classList.add('ww-card-sale-overlay');
    });
  };

  const initProductCardBadgeObserver = () => {
    if (document.documentElement.dataset.wwProductCardBadgeObserver === 'true') return;
    document.documentElement.dataset.wwProductCardBadgeObserver = 'true';

    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        initProductCardBadges();
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  const initStickyAddToCart = () => {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('[data-ww-mobile-sticky-atc]')) return;

    const section = document.querySelector('section[id^="MainProduct-"]') || document.querySelector('product-info')?.closest('section');
    if (!section) return;

    const getMainButton = () => section.querySelector('.product-form__submit, product-form button[name="add"]');
    const mainButton = getMainButton();
    if (!mainButton) return;

    const sticky = document.createElement('div');
    sticky.className = 'ww-mobile-sticky-atc';
    sticky.dataset.wwMobileStickyAtc = '';
    sticky.setAttribute('aria-label', 'Schnell zum Warenkorb');
    sticky.innerHTML = '<div class="ww-mobile-sticky-atc__price" data-ww-sticky-price></div><button type="button" class="ww-mobile-sticky-atc__button" data-ww-sticky-atc-button>In den Warenkorb</button>';
    document.body.appendChild(sticky);

    const stickyButton = sticky.querySelector('[data-ww-sticky-atc-button]');
    const stickyPrice = sticky.querySelector('[data-ww-sticky-price]');

    const syncSticky = () => {
      const button = getMainButton();
      const priceBox = section.querySelector('[id^="price-"]');
      const price =
        priceBox?.querySelector('.price__sale .price-item--sale') ||
        priceBox?.querySelector('.price__regular .price-item--regular') ||
        priceBox?.querySelector('.price-item--regular');

      if (price?.textContent.trim()) stickyPrice.textContent = price.textContent.trim();

      if (button) {
        stickyButton.disabled = button.disabled;
        const label = button.querySelector('span')?.textContent.trim();
        if (label) stickyButton.textContent = label;
      }
    };

    const updateVisibility = () => {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        sticky.classList.remove('is-visible');
        return;
      }

      const button = getMainButton();
      if (!button) {
        sticky.classList.remove('is-visible');
        return;
      }

      const rect = button.getBoundingClientRect();
      sticky.classList.toggle('is-visible', rect.bottom < 0);
    };

    stickyButton.addEventListener('click', () => {
      const button = getMainButton();
      if (button && !button.disabled) button.click();
    });

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);

    const productInfo = section.querySelector('product-info') || section;
    const observer = new MutationObserver(() => {
      syncSticky();
      updateVisibility();
    });
    observer.observe(productInfo, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'class'],
    });

    syncSticky();
    updateVisibility();
  };

  const initAll = () => {
    initProductTabsEnhancements();
    initProductDetailsShortcut();
    initBrandsCta();
    initProductCardBadges();
    initProductCardBadgeObserver();
    initStickyAddToCart();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
